module.exports = __webpack_public_path__ + "img/logo.d7d666d9.png";